/* 
Notes:
27112022 (Eddril) Used Fetch for Async/Await, Filter Fix
*/

import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { CardWorkatoConnector } from './card-workato-connector';
import { Console } from './../../services/platform-api';

const SingleWorkatoConnectors = (props) => {
  const [this_tab, setThisTab] = useState(null);

  useEffect(() => {
    Console('props.connectionTab ', props.connectionTab, 'log');
    if (props.connectionsData) {
      setThisTab(props.connectionsData.filter((connection) => connection.provider === props.connectionTab));
    }
  }, [props.connectionsData, props.connectionTab]);

  return (
    <>
      <Row>
        <Col lg={12}>
          <Row className="tabs-connection">
            {this_tab ? (
              <CardWorkatoConnector
                key={this_tab[0].id}
                connectionName={this_tab[0].name}
                connectionId={this_tab[0].id}
              />
            ) : (
              <p>Connector not found.</p>
            )}
          </Row>
        </Col>
      </Row>
    </>
  );
};

export { SingleWorkatoConnectors };
